import React from 'react';
import Heading from '../ui/Heading';
import Button from '../ui/Button';
import Section from '../ui/Section';
import img1 from '../../assets/interior/vasudharinihomes_interior_2.png'
import img2 from '../../assets/interior/vasudharinihomes_interior_1.png'
import img3 from '../../assets/interior/vasudharinihomes_interior_8.png'
import img4 from '../../assets/interior/vasudharinihomes_interior_22.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWater, faRecycle, faCar, faShield, faVideoCamera, faSun, faBolt } from '@fortawesome/free-solid-svg-icons';
import { GiWaterRecycling } from 'react-icons/gi';

const FeaturedProject = () => {
  const features = [
    { icon: <FontAwesomeIcon icon={faWater} />, name: "Water Treatment Plant" },
    { icon: <FontAwesomeIcon icon={faRecycle} />, name: "Ground Water Recharge System" },
    { icon: <FontAwesomeIcon icon={faCar} />, name: "Visitor's Car Parking" },
    { icon: <FontAwesomeIcon icon={faShield} />, name: "24 x 7 Security Service" },
    { icon: <FontAwesomeIcon icon={faVideoCamera} />, name: "CCTV Camera System" },
    { icon: <FontAwesomeIcon icon={faSun} />, name: "Solar Lightings in Common Areas" },
    { icon: <GiWaterRecycling />, name: "Sewage Treatment Plant" },
    { icon: <FontAwesomeIcon icon={faBolt} />, name: "Power Backup" }
  ];

  return (
    <Section className='py-6 sm:py-10 sm:px-5 lg:px-10 relative'>
      {/* Background decorative dots pattern */}
      <div className="absolute top-20 left-6 grid grid-cols-3 gap-2 opacity-20">
        {[...Array(9)].map((_, i) => (
          <div key={i} className="w-2 h-2 rounded-full bg-yellow-400"></div>
        ))}
      </div>
      
      {/* Decorative vertical line */}
      {/* <div className="absolute top-0 right-12 h-24 w-px bg-gray-200 hidden lg:block"></div> */}
      
      <div className='mb-10 sm:mb-14 relative'>
        {/* Decorative circles */}
        {/* <div className="absolute -top-4 -left-6 w-12 h-12 rounded-full border border-gray-200 opacity-50 hidden sm:block"></div> */}
        {/* <div className="absolute top-10 -right-4 w-8 h-8 rounded-full border border-yellow-400 opacity-50 hidden sm:block"></div> */}
        
        <div className="mb-6 text-center relative">
          <span className="bg-yellow-400 text-black font-medium py-2 px-3 rounded-full text-sm">FEATURED PROJECT</span>
          {/* Decorative lines around the featured tag */}
          {/* <div className="absolute top-1/2 left-1/4 w-16 h-px bg-gray-200 hidden sm:block"></div>
          <div className="absolute top-1/2 right-1/4 w-16 h-px bg-gray-200 hidden sm:block"></div> */}
        </div>
        <Heading level={2} className='font-medium text-center'>Vasudharini Nest</Heading>
        
        {/* Decorative underline */}
        {/* <div className="mx-auto w-24 h-px bg-yellow-400 mt-2"></div> */}
      </div>
          
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative">
        {/* Decorative corner accents */}
        <div className="absolute -top-2 -left-2 w-6 h-6 border-t-2 border-l-2 border-yellow-400 hidden lg:block"></div>
        <div className="absolute -bottom-2 -right-2 w-6 h-6 border-b-2 border-r-2 border-yellow-400 hidden lg:block"></div>
        
        <div>
          <p className="mb-10 sm:text-lg relative">
            Located in the rapidly developing Sarjapur area of Bengaluru, Vasudharini Nest features impressive 
            Spanish architecture with arcaded balconies and corridors with arches that intensify the beauty of this project.
            
            {/* Decorative quote marks */}
            <span className="absolute -left-4 -top-4 text-3xl text-yellow-400 opacity-20">"</span>
            <span className="absolute -right-4 bottom-0 text-3xl text-yellow-400 opacity-20">"</span>
          </p>
          
          <div className="mb-10 relative">
            <Heading level={4} className='font-medium'>Features</Heading>
            {/* Decorative accent line */}
            {/* <div className="absolute left-0 top-8 w-8 h-px bg-yellow-400"></div> */}
            
            <ul className="grid grid-cols-2 gap-3 mt-4">
              {features.map((feature, index) => (
                <li key={index} className="flex items-center space-x-3 group relative">
                  {/* Adding hover effect and decorative element */}
                  {/* <div className="absolute -left-2 w-0 h-full bg-yellow-100 opacity-0 group-hover:opacity-25 group-hover:w-full transition-all duration-300"></div> */}
                  <span className="text-2xl relative z-10">{feature.icon}</span>
                  <span className="relative z-10">{feature.name}</span>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="flex space-x-2 sm:space-x-4 relative">
            {/* Decorative arrow shape */}
            {/* <div className="absolute -left-6 top-1/2 transform -translate-y-1/2 w-4 h-4 border-t-2 border-r-2 border-yellow-400 rotate-45 hidden sm:block"></div> */}
            
            <Button to="/upcoming-projects" variant='outlinePrimary'>View Project Details</Button>
            <Button to="/contact" variant="outlineSecondary">Request Callback</Button>
          </div>
        </div>
        
        {/* Innovative Modern Image Layout */}
        <div className="relative h-96 sm:h-128 w-full">
          {/* Main large image */}
          <div className="absolute top-0 left-0 w-3/5 h-3/5 z-10">
            <img 
              src={img1} 
              alt="Vasudharini Nest Exterior" 
              className="w-full h-full object-cover border-4 border-white"
            />
          </div>
          
          {/* Overlapping small image top right */}
          <div className="absolute top-8 right-0 w-2/5 h-2/5 z-20">
            <img 
              src={img2} 
              alt="Vasudharini Nest Interior" 
              className="w-full h-full object-cover border-4 border-white"
            />
          </div>
          
          {/* Bottom right medium image */}
          <div className="absolute bottom-0 right-0 w-2/5 h-3/5 z-10">
            <img 
              src={img3} 
              alt="Vasudharini Nest Amenities" 
              className="w-full h-full object-cover border-4 border-white"
            />
          </div>
          
          {/* Bottom left overlapping image */}
          <div className="absolute bottom-4 left-16 w-2/5 h-2/5 z-20">
            <img 
              src={img4} 
              alt="Vasudharini Nest View" 
              className="w-full h-full object-cover border-4 border-white"
            />
          </div>
          
          {/* Decorative elements */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 border-4 border-yellow-400 z-0"></div>
          <div className="absolute bottom-6 right-12 w-16 h-16 bg-gray-100 z-0"></div>
          
          {/* Added decorative elements */}
          <div className="absolute top-6 left-12 w-4 h-4 bg-yellow-400 z-0 opacity-50"></div>
          <div className="absolute top-1/4 right-1/4 w-6 h-6 rounded-full border-2 border-dashed border-gray-300 z-0"></div>
          <div className="absolute bottom-12 left-1/3 w-10 h-10 border-2 border-gray-200 transform rotate-45 z-0"></div>
          <div className="absolute bottom-20 right-24 w-3 h-12 bg-yellow-200 opacity-40 z-0"></div>
          <div className="absolute top-1/2 right-1/3 w-5 h-5 bg-gray-100 transform rotate-12 z-0"></div>
          <div className="absolute top-3/4 left-1/2 w-20 h-px bg-yellow-400 z-0 opacity-30"></div>
          
          {/* Diagonal lines */}
          <div className="absolute top-1/3 right-0 w-16 h-px bg-gray-200 transform rotate-45 z-0"></div>
          <div className="absolute bottom-1/4 left-8 w-16 h-px bg-gray-200 transform -rotate-45 z-0"></div>
          
          {/* Corner accents for image layout */}
          <div className="absolute -top-2 -left-2 w-4 h-4 border-t border-l border-yellow-400 z-30"></div>
          <div className="absolute -top-2 -right-2 w-4 h-4 border-t border-r border-yellow-400 z-30"></div>
          <div className="absolute -bottom-2 -left-2 w-4 h-4 border-b border-l border-yellow-400 z-30"></div>
          <div className="absolute -bottom-2 -right-2 w-4 h-4 border-b border-r border-yellow-400 z-30"></div>
        </div>
      </div>
      
      {/* Bottom decorative elements */}
      <div className="absolute bottom-4 left-1/4 w-32 h-px bg-gray-200 hidden lg:block"></div>
      <div className="absolute -bottom-2 right-10 grid grid-cols-2 gap-1 opacity-30 hidden lg:block">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="w-1 h-1 rounded-full bg-yellow-400"></div>
        ))}
      </div>
    </Section>
  );
};

export default FeaturedProject;